import { DailyNotificationEmail } from './DailyNotificationEmail'
import { PipelineSettings } from './PipelineSettings'

const PersonalSettings = () => {
  return (
    <>
      <PipelineSettings />
      <DailyNotificationEmail />
    </>
  )
}

export default PersonalSettings
